const t = "_hintButton_6q17q_1", n = "_iconWrapper_6q17q_18", o = "_content_6q17q_28", r = "_arrow_6q17q_40", _ = {
  hintButton: t,
  iconWrapper: n,
  content: o,
  arrow: r
};
export {
  r as arrow,
  o as content,
  _ as default,
  t as hintButton,
  n as iconWrapper
};
//# sourceMappingURL=Hint.module.css.js.map
